<ng-container *ngIf="!isRallyCap">
  <ng-container *ngIf="worksheetItems.length > 0">
    <h5 class="pt-3">{{ 'rally.cap.videos.subheading' | translate }}</h5>
    <p class="font-size-14" [innerHTML]="'rallycap.description' | translate | markdownTranslate"></p>
    <owl-carousel-o [options]="customOptions">
      <ng-container *ngFor="let worksheetItem of worksheetItems | slice: 1">
        <ng-template carouselSlide [width]="301">
          <fgb-worksheet-item
            [worksheetItem]="worksheetItem.item"
            [worksheetId]="worksheetItem.worksheetId"
            [videoHeight]="videoHeight"
          ></fgb-worksheet-item>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </ng-container>
</ng-container>

<ng-container *ngIf="isRallyCap">
  <ng-container *ngIf="worksheetItems.length > 0">
    <ng-container *ngFor="let worksheetItem of worksheetItems | slice: 0 : 1">
      <fgb-worksheet-item
        [worksheetItem]="worksheetItem.item"
        [worksheetId]="worksheetItem.worksheetId"
        [videoHeight]="videoHeight"
      ></fgb-worksheet-item>
    </ng-container>
  </ng-container>
</ng-container>

<!-- Loading -->
<ng-template #loadingRef>
  <div class="w-100">
    <fgb-loading></fgb-loading>
  </div>
</ng-template>
